export enum Color {
  Electricity = '#62BE37',
  Solar = '#8ACF69',
  Warning = '#FF6F52',
}

export interface IFloor {
  id: number;
  isDisabled?: boolean;
  name: string;
  loadedName: string;
  ahuId: number;
  component: Record<string, unknown>;
  showAHUButton?: boolean;
  hotspotsList: IHotspot[];
  childrenSuites: ISuite[];
  activeTooltip: number | null;
}

export interface IHotspot {
  id: number;
  name: string;
  controlId?: number;
  disabled?: boolean;
  hasDataIssues?: boolean;
  isFloorVAV?: boolean;
  component?: Record<string, unknown>;
  techInfo?: {
    location?: string;
    icon?: string;
    latestReadings?: {
      amps: number | string;
      kilowatts: number | string;
    };
    devices?: string[];
  };
  style?: {
    position?: string;
    transform?: string;
    top?: string;
    left?: string;
    right?: string;
    bottom?: string;
    width?: string;
    height?: string;
    cursor?: string;
    pointerEvents?: string;
  };
  miniMapStyle?: {
    position?: string;
    transform?: string;
    top?: string;
    left?: string;
    right?: string;
    bottom?: string;
    width?: string;
    height?: string;
    cursor?: string;
  };
  hotSpotAction: (evt: MouseEvent | KeyboardEvent | number) => void;
  chipStyle: {
    position?: string;
    transform?: string;
    top?: string;
    left?: string;
    right?: string;
    bottom?: string;
    width?: string;
    height?: string;
    cursor?: string;
  };
  color: string;
  label?: string; // Optional label for the hotspot
  hasTexture?: boolean; // Optional property to indicate if the hotspot has a texture
}

interface ISuite {
  id: number;
  name: string;
  disabled: boolean;
  component?: Record<string, unknown>;
  controlsList: IHotspot[];
  styles: {
    position?: string;
    transform?: string;
    top?: string;
    left?: string;
    right?: string;
    bottom?: string;
    width?: string;
    height?: string;
  };
  activeTooltip: number | null;
}
